import { HostContext, nameof, useAsyncMemo } from "@buzzeasy/shared-frontend-utilities";
import i18next, { Resource } from "i18next";
import { PropsWithChildren, ReactElement, useContext } from "react";
import { I18nextProvider, initReactI18next } from "react-i18next";
import CallTranslatorFragment from "../../fragments/CallTranslatorFragment";
import { translations } from "../../translations";

const translationOverrideLang = "OVERRIDE";

export default function TranslationProvider({ children }: PropsWithChildren): ReactElement {
  const { language, translations: overrideTranslations } = useContext(HostContext);

  const i18nInstance = useAsyncMemo(
    async () => {
      const instance = i18next.createInstance();

      const lng = overrideTranslations
        ? translationOverrideLang
        : language;

      const fragmentTranslations = overrideTranslations?.[nameof({ CallTranslatorFragment })];
      const resources = { ...translations, [translationOverrideLang]: { translation: fragmentTranslations ?? {} } } as unknown as Resource;

      await instance
        .use(initReactI18next)
        .init({
          resources,
          lng,
          fallbackLng: "en-US",
          returnEmptyString: false,
          interpolation: {
            escapeValue: false,
          },
        });

      return instance;
    },
    [language, overrideTranslations],
  );

  if (!i18nInstance)
    return <></>;

  return (
    <I18nextProvider i18n={i18nInstance}>
      {children}
    </I18nextProvider>
  );
}
